import React, { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material';

import { EnvelopeRecalculationEnd } from '../../../../library/layout-geometry/truss-envelopes/calculation/envelopeCalculationResult';

interface Props {
  disabled?: boolean;
  onRecalculate: (end: EnvelopeRecalculationEnd) => void;
}

export function RecalculateButton(props: Props) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const menuIsOpen = !!menuAnchorEl;

  return (
    <>
      <ButtonGroup variant="outlined" disabled={props.disabled}>
        <Button
          variant="outlined"
          disabled={props.disabled}
          onClick={() => {
            props.onRecalculate('both');
          }}
        >
          Recalculate Now
        </Button>

        <Button size="small" onClick={(event) => setMenuAnchorEl(event.currentTarget)}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={menuAnchorEl}
        open={menuIsOpen}
        onClose={() => {
          setMenuAnchorEl(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            props.onRecalculate('left');
          }}
        >
          Recalculate Left End Only
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            props.onRecalculate('right');
          }}
        >
          Recalculate Right End Only
        </MenuItem>
      </Menu>
    </>
  );
}
